import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";

import Home from "../screens/Home";
import ProductsDashboard from "../screens/ProductsDashboard";
import NewProduct from "../screens/NewProduct";
import Drafts from "../screens/Drafts";
import Released from "../screens/Released";
import Comments from "../screens/Comments";
import Scheduled from "../screens/Scheduled";
import Customers from "../screens/Customers";
import StaffList from "../screens/StaffList";
import Promote from "../screens/Promote";
import Notification from "../screens/Notification";
import Settings from "../screens/Settings";
import UpgradeToPro from "../screens/UpgradeToPro";
import MessageCenter from "../screens/MessageCenter";
import ExploreCreators from "../screens/ExploreCreators";
import AffiliateCenter from "../screens/AffiliateCenter";
import SignUp from "../screens/SignUp";
import SignIn from "../screens/SignIn";
import Earning from "../screens/Earning";
import Refunds from "../screens/Refunds";
import Payouts from "../screens/Payouts";
import Statements from "../screens/Statements";
import Shop from "../screens/Shop";
import PageList from "../screens/PageList";

import PrivateRoute from "../router-manager/PrivateRoute";
import PublicRoute from "../router-manager/PublicRoute";
import PageNotFound from "../screens/PageNotFound";
import PrivacyPolicy from "../screens/Privacy-policy";
import SocialLinks from "../screens/Social-Links";
import { BrandProfile } from "../screens/BrandProfile";
import Redeem from "../screens/Redeem";
import MarketplaceActivity from "../screens/MarketplaceActivity";
import Search from "../screens/Search";
import ResetPassword from "../screens/ResetPassword";
import Product from "../screens/Product";
import Category from "../screens/Category";
import Collection from "../screens/Collection";
import Monetize from "../screens/Monetize";
import Addresses from "../screens/Addresses";
import Experience from "../screens/Experience";
import TestPage from "../screens/Test";
import TicketingProviders from "../screens/TicketingProvider";
import IntegrationList from "../screens/Integrations";
import Raffle from "../screens/Raffle";
import TokenWallet from "../screens/TokenWallet";
import BrandBoxFrontHome from "../screens/CustomizeInterface";
import TokenStore from "../screens/CustomizeInterface/TokenStore";
import ComMarketPlace from "../screens/CustomizeInterface/ComMarketplace";

const RouteList = () => {
	return (
		<Router>
			<Switch>
				<PublicRoute path="/sign-in" component={SignIn} />
				<PublicRoute path="/sign-up" component={SignUp} />
				<PublicRoute path="/reset-password" component={ResetPassword} />
				<PrivateRoute exact path="/" component={Home} />
				<PrivateRoute path="/test/:id" exact component={TestPage} />
				<PrivateRoute
					path="/products/dashboard"
					exact
					component={ProductsDashboard}
				/>
				<PrivateRoute path="/product" exact component={Product} />
				<PrivateRoute path="/token-wallet" component={TokenWallet} />
				<PrivateRoute path="/category" exact component={Category} />
				<PrivateRoute path="/collection" exact component={Collection} />
				<PrivateRoute
					path="/customize/home"
					exact
					component={BrandBoxFrontHome}
				/>
				<PrivateRoute
					path="/customize/token-store"
					exact
					component={TokenStore}
				/>
				<PrivateRoute
					path="/customize/com-marketplace"
					exact
					component={ComMarketPlace}
				/>
				{/* <PrivateRoute path="/customize/banner" exact component={Banner} /> */}
				{/* <PrivateRoute
					path="/customize/title_description"
					exact
					component={TitleDescription}
				/> */}
				<PrivateRoute
					path="/products/add"
					exact
					component={NewProduct}
				/>
				<PrivateRoute
					path="/products/edit/:id"
					exact
					component={NewProduct}
				/>
				<PrivateRoute
					path="/products/drafts"
					exact
					component={Drafts}
				/>
				<PrivateRoute
					path="/products/comments"
					exact
					component={Comments}
				/>
				<PrivateRoute
					path="/products/scheduled"
					exact
					component={Scheduled}
				/>
				<PrivateRoute
					path="/products/minted"
					exact
					component={Released}
				/>
				<PrivateRoute
					path="/products/redeem"
					exact
					component={Redeem}
				/>
				<PrivateRoute
					path="/products/experience"
					exact
					component={Experience}
				/>
				<PrivateRoute
					path="/customers/overview"
					exact
					component={Customers}
				/>
				<PrivateRoute
					path="/customers/list/:type/:id?"
					exact
					component={StaffList}
				/>
				<PrivateRoute
					path="/marketplace/listing"
					exact
					component={Shop}
				/>
				<PrivateRoute path="/finance" exact component={Monetize} />
				<PrivateRoute path="/raffle" exact component={Raffle} />
				<PrivateRoute
					path="/marketplace/activity"
					exact
					component={MarketplaceActivity}
				/>
				<PrivateRoute
					path="/income/earning"
					exact
					component={Earning}
				/>
				<PrivateRoute
					path="/income/refunds"
					exact
					component={Refunds}
				/>
				<PrivateRoute
					path="/income/payouts"
					exact
					component={Payouts}
				/>
				<PrivateRoute
					path="/income/statements"
					exact
					component={Statements}
				/>
				<PrivateRoute path="/promote" exact component={Promote} />
				<PrivateRoute
					path="/notification"
					exact
					component={Notification}
				/>
				<PrivateRoute path="/settings" exact component={Settings} />
				<PrivateRoute
					path="/settings/privacy-policy"
					exact
					component={PrivacyPolicy}
				/>
				<PrivateRoute
					path="/settings/social-links"
					exact
					component={SocialLinks}
				/>
				<PrivateRoute
					path="/settings/brand"
					exact
					component={BrandProfile}
				/>
				<PrivateRoute
					path="/settings/addresses"
					exact
					component={Addresses}
				/>
				<PrivateRoute
					path="/settings/ticket-provider"
					exact
					component={TicketingProviders}
				/>
				<PrivateRoute
					path="/settings/integrations"
					exact
					component={IntegrationList}
				/>
				<PrivateRoute
					path="/upgrade-to-pro"
					exact
					component={UpgradeToPro}
				/>
				<PrivateRoute
					path="/message-center"
					exact
					component={MessageCenter}
				/>
				<PrivateRoute
					path="/explore-brands"
					exact
					component={ExploreCreators}
				/>
				<PrivateRoute
					path="/affiliate-center"
					exact
					component={AffiliateCenter}
				/>
				<PrivateRoute path="/pagelist" exact component={PageList} />
				<PrivateRoute path="/search" exact component={Search} />
				<PrivateRoute path="*" component={PageNotFound} />
				<PublicRoute path="*" component={PageNotFound} />
			</Switch>
		</Router>
	);
};

export default RouteList;
